export const HANDLE_GET_WEBHOOK_LIST ="HANDLE_GET_WEBHOOK_LIST";
export const HANDLE_GET_WEBHOOK_EVENTS ="HANDLE_GET_WEBHOOK_EVENTS";
export const HANDLE_REGISTER_WEBHOOK ="HANDLE_REGISTER_WEBHOOK";
export const HANDLE_DELETE_WEBHOOK ="HANDLE_DELETE_WEBHOOK";
export const HANDLE_PATCH_WEBHOOK ="HANDLE_PATCH_WEBHOOK";
